import useSwitchPMDLanguage from 'remotePMD/hooks/useSwitchPMDLanguage';
import internationalization from 'src/i18n/i18n';

const useSwitchLanguage = () => {
  const switchPmdLanguageHook = useSwitchPMDLanguage();

  // PMD
  const switchPmdLanguage = (languageCode) =>
    switchPmdLanguageHook(languageCode);
  // CONTAINER
  const switchContainerLanguage = (languageCode) =>
    internationalization.changeLanguage(languageCode);
  // ALL
  const switchAllLanguages = (languageCode) => {
    switchPmdLanguage(languageCode);
    switchContainerLanguage(languageCode);
  };

  return {
    switchPmdLanguage,
    switchContainerLanguage,
    switchAllLanguages,
  };
};

export default useSwitchLanguage;
